import { createSlice} from '@reduxjs/toolkit';
import type{  PayloadAction } from '@reduxjs/toolkit';

export interface ActiveSessionPayload {
  sessionId: string;
  rtcToken?: string;
  channelName?: string;
  type: string; // 'chat' | 'call' | 'video'
  expertCode: string;
}

interface ActiveSessionState {
  session: ActiveSessionPayload | null;
}

// Read from localStorage on mount so it survives refreshes
const storedSession = localStorage.getItem('active_session');
const initialState: ActiveSessionState = {
  session: storedSession ? JSON.parse(storedSession) : null,
};

export const activeSessionSlice = createSlice({
  name: 'activeSession',
  initialState,
  reducers: {
    setActiveSession: (state, action: PayloadAction<ActiveSessionPayload>) => {
      state.session = action.payload;
      localStorage.setItem('active_session', JSON.stringify(action.payload));
    },
    clearActiveSession: (state) => {
      state.session = null;
      localStorage.removeItem('active_session');
    },
  },
});

export const { setActiveSession, clearActiveSession } = activeSessionSlice.actions;
export default activeSessionSlice.reducer;